import { Backdrop, Dialog, styled } from "@mui/material";

export const CustomBackdrop = styled(Backdrop)(({ theme }) => ({
  backgroundColor: "#00000040", // Semi-transparent black
  backdropFilter: "blur(18px)", // Frosted glass effect
}));

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "24px",
  },
}));
